import { pipelineConfigs } from './reportConfigs/PipelineConfig';
import { interviewConfigs } from './reportConfigs/InterviewConfig';
import { offerConfigs } from './reportConfigs/OfferConfigs';
import { hireConfigs } from './reportConfigs/HiresConfigs';
import { rejectionConfigs } from './reportConfigs/RejectionConfig';
import { contactsConfigs } from './reportConfigs/ContactsConfig';
import { jobsConfigs } from './reportConfigs/JobsConfig';
import { eeoConfigs } from './reportConfigs/EEOConfigs';
import { flowHealthConfigs } from './reportConfigs/FlowHealthConfigs';
import { requisitionsConfigs } from './reportConfigs/RequisitionsConfig';
import { surveyConfigs } from './reportConfigs/SurveyConfig';
import { liveJobPipelineConfigs } from './reportConfigs/LiveJobPipelineConfig';
import { recruiterPerformanceConfigs } from './reportConfigs/RecruiterPerformanceConfig';

export const getReportCategories = ({
  flags,
}: {
  flags?: Record<string, unknown>;
}) => {
  const { feReq, feSurvey, liveJobPipelineReports, feRecruiterPerformance } =
    flags ?? {};
  const categories = [
    ...(liveJobPipelineReports
      ? [
          {
            label: 'Current job pipeline',
            id: 'live_job_pipeline',
            active: true,
            scrollRefID: 'live_job_pipeline-holder',
            scrollClassName: 'live_job_pipeline',
          },
        ]
      : []),

    {
      label: 'Pipeline history',
      id: 'pipelines',
      active: !liveJobPipelineReports,
      scrollRefID: 'pipelines-holder',
      scrollClassName: 'pipeline',
    },
    {
      label: 'Interviews',
      id: 'interviews',
      active: false,
      scrollRefID: 'interviews-holder',
      scrollClassName: 'interviews',
    },
    {
      label: 'Offers',
      id: 'offers',
      active: false,
      scrollRefID: 'offers-holder',
      scrollClassName: 'offers',
    },
    {
      label: 'Hires',
      id: 'hires',
      active: false,
      scrollRefID: 'hires-holder',
      scrollClassName: 'hires',
    },
    {
      label: 'Rejections',
      id: 'rejections',
      active: false,
      scrollRefID: 'rejections-holder',
      scrollClassName: 'rejections',
    },
    {
      label: 'Candidates',
      id: 'contacts',
      active: false,
      scrollRefID: 'contacts-holder',
      scrollClassName: 'contacts',
    },
    {
      label: 'Jobs',
      id: 'jobs',
      active: false,
      scrollRefID: 'jobs-holder',
      scrollClassName: 'jobs',
    },
    {
      label: 'EEO',
      id: 'eeo',
      active: false,
      scrollRefID: 'eeo-holder',
      scrollClassName: 'eeoc',
    },
    {
      label: 'Flow Health',
      id: 'flow-health',
      active: false,
      scrollRefID: 'flow-health',
      scrollClassName: 'flow-health',
    },
  ];

  if (feSurvey) {
    categories.push({
      label: 'Survey',
      id: 'survey',
      active: false,
      scrollRefID: 'survey-holder',
      scrollClassName: 'survey',
    });
  }

  if (feReq) {
    categories.push({
      label: 'Requisitions',
      id: 'requisitions',
      active: false,
      scrollRefID: 'requisitions-holder',
      scrollClassName: 'requisitions',
    });
  }

  if (feRecruiterPerformance) {
    categories.push({
      label: 'Recruiter performance',
      id: 'recruiter_performance',
      active: false,
      scrollRefID: 'recruiter-performance-holder',
      scrollClassName: 'recruiter_performance',
    });
  }

  return categories;
};

export const reportConfigs = ({
  flags,
}: {
  flags?: Record<string, unknown>;
}) => {
  const { feSurvey, feReq, liveJobPipelineReports, feRecruiterPerformance } =
    flags ?? {};

  return [
    ...(liveJobPipelineReports ? liveJobPipelineConfigs : []),
    ...pipelineConfigs,
    ...interviewConfigs,
    ...offerConfigs,
    ...hireConfigs,
    ...rejectionConfigs,
    ...contactsConfigs,
    ...jobsConfigs,
    ...eeoConfigs,
    ...flowHealthConfigs,
    ...(feSurvey ? surveyConfigs : []),
    ...(feReq ? requisitionsConfigs : []),
    ...(feRecruiterPerformance ? recruiterPerformanceConfigs : []),
  ];
};
